import styled from 'styled-components';

import { Color, FontWeight, InputTheme, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { InputValueBoxBaseStyle } from '../../theme';
import { ValidationBar } from '../validationBar/validationBar.component';

import { BaseInputProps, IconContaierProps } from './input.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const InputContainer: StyledComponent<'div'> = styled.div`
  position: relative;
`;

export const BaseInput: StyledComponent<'input', BaseInputProps> = styled.input<BaseInputProps>`
  ${InputValueBoxBaseStyle}
  padding: 17px 16px;
  width: calc(100% - 32px);
  height: auto;
  display: inline;

  ${({ $inputTheme }: BaseInputProps): string | false => $inputTheme === InputTheme.Small && `
    font-size: 14px;
    width: calc(100% - 56px);
    padding: 12px 38px 12px 16px;
  `}
  ${({ $withRightButton }: BaseInputProps): string | false => !!$withRightButton && `
    width: calc(100% - 83px);
    padding: 18px 65px 18px 16px;
  `}
  ${({ $withIcon, $inputTheme }: BaseInputProps): string | false => !!$withIcon && $inputTheme !== InputTheme.Small && `
    width: calc(100% - 56px);
    padding: 18px 38px 18px 16px;
  `}
`;

export const TogglePasswordType: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${ZIndex.Min};
`;

export const StyledValidationBar: StyledComponent<typeof ValidationBar> = styled(ValidationBar)`
  margin-top: 12px;

  & + &,
  ${InputContainer} + & {
    margin-top: 12px;
  }
`;

export const IconContainer: StyledComponent<'button', IconContaierProps> = styled.button.attrs({ type: 'button' })<IconContaierProps>`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: ${({ $withOnClick }: IconContaierProps): string => $withOnClick ? 'initial' : 'none'};
  cursor: ${({ $withOnClick }: IconContaierProps): string => $withOnClick ? 'pointer' : 'default'};
`;
